import { Grid } from "@mui/material";
import { JSX } from "react";
import { Typography } from "@platform/design-system";

interface Props {
  title?: string;
  subtitle?: string;
}

function Title({ title, subtitle }: Props): JSX.Element {
  return (
    <Grid container size={12} mb={3} direction="column">
      {title && (
        <Typography variant="display-medium" align="center" mb={1}>
          {title}
        </Typography>
      )}
      {subtitle && (
        <Typography align="center" variant="body-large">
          {subtitle}
        </Typography>
      )}
    </Grid>
  );
}

export default Title;
